import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Source } from '@empathy/survey/base';

@Component({
  selector: 'empathy-list-source-item',
  templateUrl: 'list-source-item.component.html',
  styleUrls: ['./list-source-item.component.scss', './_list-source-item-theme.component.scss']
})
export class ListSourceItemComponent {
  @Input() active: boolean;
  @Input() source: Source;

  @Output() activate = new EventEmitter<string>();
}
